var plugin_default = {
  "alignLeft": "esJxS",
  "textWrapNowrap": "MKCk0",
  "alignRight": "DuFgi",
  "alignCenter": "jT4Ve",
  "sizeFullWidth": "wvaKs",
  "renderedInTable": "_6NdpI",
  "sizeOriginal": "v3-lx",
  "sizeContent": "_358WX",
  "sizeSmall": "Ffg0s",
  "sizeSmallCenter": "PKXEu",
  "flex": "ozdbP",
  "atomic": "dr0V0",
  "embed": "mt9xN",
  "horizontalScrollbar": "T6KJm",
  "pluginContainerMobile": "xI1PL"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
